/* Basson Workwear diagnostic fix: disable cross-document View Transitions on this unpublished theme copy.
   This avoids Chromium renderer crashes/white screens during page navigation while preserving normal navigation. */
(function () {
  const disableStyle = document.createElement('style');
  disableStyle.textContent = '@view-transition { navigation: none; }';
  (document.head || document.documentElement).appendChild(disableStyle);

  const removeRenderBlocker = () => {
    document.getElementById('view-transition-render-blocker')?.remove();
  };

  removeRenderBlocker();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeRenderBlocker, { once: true });
  }
})();
